var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c("div", { staticClass: "relative-position loader" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-card",
              {
                staticClass: "md-card q-mt-lg q-pa-lg relative-position",
                attrs: { color: "white", "text-color": "black" }
              },
              [
                _c("q-card-title", [
                  _vm._v(
                    "\n            Helpful Links for Constant Contact\n          "
                  )
                ]),
                _c("q-card-separator"),
                _c(
                  "q-card-main",
                  [
                    _c(
                      "q-list",
                      { attrs: { highlight: "" } },
                      [
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: { flat: "", color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLink(
                                          "https://www.constantcontact.com/"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " Visit Constant\n                    Contact\n                  "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-item",
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-item-tile", {
                                  attrs: { icon: "link", color: "primary" }
                                })
                              ],
                              1
                            ),
                            _c(
                              "q-item-main",
                              [
                                _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      label: "Send Profile Update Email to:",
                                      flat: "",
                                      color: "primary"
                                    }
                                  },
                                  [
                                    _c(
                                      "q-popover",
                                      [
                                        _c(
                                          "q-list",
                                          {
                                            attrs: { separator: "", link: "" }
                                          },
                                          [
                                            _c(
                                              "q-item",
                                              {
                                                attrs: { label: "" },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.sendCampaign([
                                                      "[WEBSITE] Affiliate",
                                                      "[WEBSITE] General Contractor",
                                                      "[WEBSITE] Specialty Contractor"
                                                    ])
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "All (Affiliates, General Contractors, Specialty Contractors)>\n                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-item",
                                              {
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.sendCampaign([
                                                      "[WEBSITE] Affiliate"
                                                    ])
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          Affiliates\n                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-item",
                                              {
                                                attrs: { label: "" },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.sendCampaign([
                                                      "[WEBSITE] General Contractor"
                                                    ])
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          General Contractors\n                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-item",
                                              {
                                                attrs: { label: "" },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.sendCampaign([
                                                      "[WEBSITE] Specialty Contractor"
                                                    ])
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          Specialty Contractors\n                        "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-item",
                                              {
                                                attrs: { label: "" },
                                                nativeOn: {
                                                  click: function($event) {
                                                    return _vm.sendCampaign([
                                                      "Test List"
                                                    ])
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                          Test List\n                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "q-card",
              {
                staticClass: "md-card q-mt-lg q-pa-lg relative-position",
                attrs: { color: "white", "text-color": "black" }
              },
              [
                _c("q-card-title", [
                  _vm._v(
                    "\n            Helpful Notes for Constant Contact\n          "
                  )
                ]),
                _c("q-card-separator"),
                _c("q-card-main", [
                  _c("p", [
                    _c("strong", [
                      _vm._v(
                        "The following is a brief explanation of the integration between this application and Constant\n              Contact"
                      )
                    ])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Every day at 2:00 a.m., an automated job runs. This job will upload AGC persons who are members to\n              Constant Contact. Additionally any person who is related to a Group or Committee that has CC Sync\n              enabled will also be uploaded to Constant Contact. Each user has the ability to add or remove themselves\n              from the Weekly Updates and Legislative Updates groups via the website and the sync job will respect\n              this. The only caveat is if the user Unsubscribes from Constant Contact directly. If they do this, they\n              will not be able to add themselves back on the list from the website account profile edit interface."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      'Note the above "send an email campaign" will send an email campaign to all persons who are members to\n              update their profiles. This button will send a Constant Contact campaign to all persons who are members.\n              Within the email, they will receive a notification encouraging them to update their information and a\n              temporary link that will automatically log them in to their profile.'
                    )
                  ]),
                  _c("p", [
                    _vm._v("There is a campaign in Constant Contact called "),
                    _c("strong", [
                      _vm._v(
                        '"Profile Update - Base Template [DO NOT\n              DELETE]"'
                      )
                    ]),
                    _vm._v(" at "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "https://ui.constantcontact.com/rnavmap/evaluate.rnav?activepage=ecampaign.view&pageName=ecampaign.view&action=newedit&popin=true&campaign=39c94c32-d178-418d-8d87-89d50c14567a",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(
                          "https://ui.constantcontact.com/rnavmap/evaluate.rnav?activepage=ecampaign.view&pageName=ecampaign.view&action=newedit&popin=true&campaign=39c94c32-d178-418d-8d87-89d50c14567a"
                        )
                      ]
                    ),
                    _vm._v(
                      "\n              that is used for sending this email. It must "
                    ),
                    _c("strong", [_vm._v("only")]),
                    _vm._v(" be edited by a developer and "),
                    _c("u", [_vm._v("never\n                deleted")]),
                    _vm._v(".")
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }